import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgRotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "10 8 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 20.5l4.4 4.4-4.4 4.4v-3.41c-5.016-.506-8.8-2.728-8.8-5.39 0-2.662 3.784-4.884 8.8-5.39v2.189c-3.795.374-6.6 1.661-6.6 3.201s2.805 2.827 6.6 3.201V20.5zm11 0c0-1.54-2.805-2.827-6.6-3.201V15.11c5.016.506 8.8 2.728 8.8 5.39 0 2.376-3.476 4.73-7.7 5.5v-2.2c3.267-.473 5.5-1.903 5.5-3.3zm-11-5.39S21.14 15 22 15c.86 0 2.2.11 2.2.11v2.189S22.86 17.2 22 17.2c-.86 0-2.2.099-2.2.099V15.11z",
    fill: "currentColor"
  })));
}

export { SvgRotation as ReactComponent };
